import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';
import { DSR_TOOLING_ROUTES } from './routes';
import { DSRToolingScreen } from '@/screens/dsr-tooling-screen';
import { DSRToolingStackParams } from './types';
import { useDefaultStackScreenOptions } from '@/hooks/use-default-stack-screen-options';

const Stack = createStackNavigator<DSRToolingStackParams>();

export const DSRToolingStack: React.FC = () => {
  const options = useDefaultStackScreenOptions();
  return (
    <Stack.Navigator screenOptions={options}>
      <Stack.Screen
        component={DSRToolingScreen}
        name={DSR_TOOLING_ROUTES.Base}
      />
    </Stack.Navigator>
  );
};
